// extracted by mini-css-extract-plugin
export default {"confirmModal":"ModalConfirm_confirmModal__L-ucP","cancelButton":"ModalConfirm_cancelButton__zalKb","delete":"ModalConfirm_delete__JPGMC"};